import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { getReactQueryOptions } from '@_/utils-frontend';
import { publicApiQueryClient } from '#src/api.ts';
import { ReviewBookingPage } from '#src/pages/ReviewPage/index.ts';

export const Route = createFileRoute('/{-$locale}/_auth/booking_/$bookingId_/review')({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const { bookingId } = params;
    await queryClient.ensureQueryData(bookingQueryOptions({ bookingId }));
  }
});

function RouteComponent() {
  const { bookingId } = Route.useParams();

  const query = useSuspenseQuery(bookingQueryOptions({ bookingId }));
  const booking = query.data.data;

  return <ReviewBookingPage booking={booking} />;
}

function bookingQueryOptions({ bookingId }: { bookingId: string }) {
  return getReactQueryOptions(publicApiQueryClient.bookings.get, {
    params: { id: bookingId }
  });
}
